/** 后台增量拉取间隔。保存动作仍会立即同步，不受此间隔影响。 */
export const SYNC_INTERVAL_MS = 60_000;
/** 被服务器拒绝后允许做一次完整回填；短时间内重复拒绝不能再次拉全量。 */
export const REJECTION_RECONCILE_COOLDOWN_MS = 5 * 60_000;

/**
 * 已有同步在跑时，后台检查不排队，避免慢网络下一轮接一轮地占用页面。
 * 用户主动保存或手动同步仍保留一次跟随执行机会。
 */
export function shouldQueueBusySync(reason: string): boolean {
  return !['interval', 'visible', 'pageshow', 'focus'].includes(reason);
}

export function shouldRunRejectedReconcile(lastAt: number, now = Date.now()): boolean {
  return now - lastAt >= REJECTION_RECONCILE_COOLDOWN_MS;
}
